import React from "react";
import { Formik, ErrorMessage, Form } from "formik";
import { Box, Button } from "@material-ui/core";
import { EN } from "../../ui/constants";
import { FormControl, Image } from "react-bootstrap";
import carImage from "../../images/car.png";

class ResetPasswordForm extends React.Component {
  validateEmail = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  };

  render() {
    const { forgotPassword, isLargeScreen, isMediumScreen } = this.props;
    return (
      <Box
        display="flex"
        width="100%"
        flexDirection={["column", "column", "column", "row"]}
        alignItems="center"
      >
        <Box
          width={["100%", "80%", "80%", "60%"]}
          display={isMediumScreen ? "none" : "block"}
          mt={[0, 0, 0, 20]}
        >
          <Box style={{ display: isLargeScreen ? "none" : "flex" }}>
            <Image src={carImage} alt="Car Image" width="100%" />
          </Box>
        </Box>
        <Box
          width={["100%", "80%", "80%", "60%"]}
          display={["block", "flex"]}
          height={["auto", "auto", "auto", "540px"]}
          p="12px 20px"
          justifyContent="center"
          alignItems="center"
        >
          <Formik
            initialValues={{
              email: "",
            }}
            validate={(values) => {
              let errors = {
                email: this.validateEmail(values.email),
              };

              Object.keys(errors).forEach((key) => {
                if (errors[key] === undefined) {
                  delete errors[key];
                }
              });
              return errors;
            }}
            onSubmit={(values) => {
              forgotPassword(values.email);
            }}
          >
            {({ values, handleChange, handleSubmit, handleBlur }) => (
              <Box width={["auto", "350px"]}>
                <Form onSubmit={(...args) => handleSubmit(...args)}>
                  <Box
                    className="heading-text-font"
                    color="#000"
                    fontSize="20px"
                    fontWeight="700"
                    mb={2}
                  >
                    <span style={{ color: "#E00000" }}>Forgot</span> Password
                  </Box>
                  <Box className="textStyles" mb={2}>
                    You will receive a link to create a new password via email.
                  </Box>
                  <Box>
                    <FormControl
                      placeholder="Email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      name="email"
                      type="email"
                      className="form-control"
                    />
                    <ErrorMessage
                      className="errorMsg"
                      name="email"
                      component="div"
                    />
                  </Box>
                  <Box mt={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      style={{ backgroundColor: "#E00000", color: "white" }}
                      type="submit"
                    >
                      {EN.send}
                    </Button>
                  </Box>
                </Form>
              </Box>
            )}
          </Formik>
        </Box>
      </Box>
    );
  }
}

export default ResetPasswordForm;
